import { Flex, Spin, Typography, Button, Space } from "antd";
import { useTranslate } from "#src/hooks";

export const DragAndDropArea = ({ inProgress }: { inProgress: boolean }) => {
  const t = useTranslate();
  if (inProgress)
    return (
      <Space>
        <Typography.Text style={{ fontSize: 14 }}>
          {t("components.templates.settings.uploader.uploadingInProgress")}
        </Typography.Text>
        <Spin spinning={true} />
      </Space>
    );
  return (
    <Flex vertical style={{ margin: 10 }} gap={5} align="center">
      <Typography.Text style={{ fontSize: 14 }}>
        {t("components.templates.settings.uploader.dragAndDrop")}
      </Typography.Text>
      <Typography.Text style={{ fontSize: 14 }}>
        {t("components.templates.settings.uploader.or")}
      </Typography.Text>
      <Button type="primary" shape="round">
        {t("components.templates.settings.uploader.browse")}
      </Button>
    </Flex>
  );
};
